import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import ExpensesLayout from "./ExpensesLayout";
import { SECTIONS, EXPENSES_BASE, SPEND_TIMELINE_VIEW, expensesDefaultRoute } from "./config";

// Construye el árbol de rutas /expenses desde la config de navegación, de
// modo que el sub-menú y las rutas nunca diverjan. Espeja los bloques de rutas
// de las otras mini-apps (una app, sub-menú plano) envuelto en
// RoleProtectedRoute.
const children: RouteObject[] = [
  { index: true, element: <Navigate to={expensesDefaultRoute} replace /> },
  ...SECTIONS.map((item) => ({ path: item.id, element: item.element })),
  // «¿Cuándo se gastó?» ahora vive dentro de Gastos: los enlaces viejos siguen sirviendo.
  { path: "timeline", element: <Navigate to={`${EXPENSES_BASE}/expenses?view=${SPEND_TIMELINE_VIEW}`} replace /> },
];

export const expensesRoute: RouteObject = {
  path: EXPENSES_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <ExpensesLayout />,
      children,
    },
  ],
};
